import { createBrowserRouter } from 'react-router'
import type { RouteObject } from 'react-router'
import { GuestOnly } from '../features/auth/GuestOnly'
import { LoginPage } from '../features/auth/LoginPage'
import { RegisterPage } from '../features/auth/RegisterPage'
import { RequireAuth } from '../features/auth/RequireAuth'
import { ResetPasswordPage } from '../features/auth/ResetPasswordPage'
import { ChatPage } from '../features/chat/ChatPage'
import { ROUTES } from '../routes'
import type { RouteName } from '../routes'
import { NotFoundPage } from './NotFoundPage'
import { Root } from './Root'

/** One entry per page of `routes.ts`: a page missing here does not compile. */
const PAGES: Record<RouteName, RouteObject> = {
  chat: { path: ROUTES.chat.path, element: <ChatPage /> },
  login: { path: ROUTES.login.path, element: <LoginPage /> },
  register: { path: ROUTES.register.path, element: <RegisterPage /> },
  resetPassword: { path: ROUTES.resetPassword.path, element: <ResetPasswordPage /> },
  account: {
    path: ROUTES.account.path,
    lazy: async () => ({ Component: (await import('../features/account/AccountPage')).AccountPage }),
  },
  moderation: {
    path: ROUTES.moderation.path,
    lazy: async () => ({ Component: (await import('../features/moderation/ModerationPage')).ModerationPage }),
  },
  terms: {
    path: ROUTES.terms.path,
    lazy: async () => ({ Component: (await import('../features/legal/TermsPage')).TermsPage }),
  },
  privacy: {
    path: ROUTES.privacy.path,
    lazy: async () => ({ Component: (await import('../features/legal/PrivacyPage')).PrivacyPage }),
  },
}

/** The router of the app. */
export const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { element: <GuestOnly />, children: [PAGES.login, PAGES.register] },
      { element: <RequireAuth />, children: [PAGES.chat, PAGES.account, PAGES.moderation] },
      PAGES.resetPassword,
      PAGES.terms,
      PAGES.privacy,
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
